export enum NoticesType {
  SUCCESS = 'success',
  INFO = 'info',
  ALERT = 'alert'
}
